import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'tg',
    fullName: 'Tajik',
    nativeName: 'Тоҷикӣ',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Чизи аҷибе меояд",
    landing_subtitle: "ArgVoid як студияи таҳияи барнома ва бозӣ аст. Огоҳ бошед, чизҳои нав ба зудӣ меоянд!",
    select_language: "Забонро интихоб кунед",
    search_placeholder: "Ҷустуҷӯи забонҳо...",
    terms_title: "Шартҳои хизматрасонӣ",
    policy_title: "Сиёсати Корбурди Маълумоти Шахсӣ",
    cookies_title: "Сиёсати кукиҳо",
    terms_content: `
        <strong>1. Қабули шартҳои</strong><br>
        Бо дастрасӣ ба ArgVoid, ин Шартҳои хидмат қабул карда мешаванд. Агар ин шартҳо розӣ набошанд, хидмат набояд истифода шавад.<br><br>

        <strong>2. Истифодаи платформаи</strong><br>
        ArgVoid ва замимаҳои он "чун ҳаст" бо ҳадафҳои иттилоотӣ ва эҷодӣ пешниҳод карда мешаванд. Хидмат бояд танҳо барои мақсадҳои қонунӣ истифода шавад.<br><br>

        <strong>3. Рафтори манъшуда</strong><br>
        Истифодаи осебпазирии сайт, спам ё кӯшиши дастрасии беиҷозат ба инфрасохтор қатъиян манъ аст.<br><br>

        <strong>4. Радди масъулият </strong><br>
        Платформа ва хидматҳо метавонанд дар вақти дилхоҳ бидуни огоҳӣ тағир дода шаванд. Дар бораи вақти корӣ ё мавҷудияти хидмат ҳеҷ гуна кафолат дода намешавад.
    `,
    policy_content: `
        <strong>1. Маҷмӯаи маълумот</strong><br>
        Платформа дар айни замон тасдиқи корбар ё эҷоди ҳисобро талаб намекунад. Аз меҳмонон ягон маълумоти мушаххаскунандаи шахсият (ба монанди ном ё суроғаҳои почтаи электронӣ) фаъолона ҷамъоварӣ карда намешавад.<br><br>

        <strong>2. Истифодаи Data</strong><br>
        Барои фаҳмидани трафики сайт ва такмил додани барномаҳо, таҳлилҳои асосӣ ва беном ҷамъоварӣ карда мешаванд. Ин маълумот ба шахсияти корбарони инфиродӣ алоқаманд нест.<br><br>

        <strong>3. Хидматҳои тарафи сеюм</strong><br>
        Провайдерҳои тарафи сеюм метавонанд барои хидматрасонии хостинг ва таҳлил истифода шаванд. Таҷрибаҳои махфияти ин провайдерҳои мувофиқ маълумоти беномро, ки дар инфрасохтори онҳо коркард мешаванд, идора мекунанд.<br><br>

        <strong>4. Амнияти маълумот </strong><br>
        Барои ҳифзи платформа чораҳои бехатарии оқилона андешида мешаванд. Аммо, ягон усули интиқол тавассути Интернет комилан бехатар нест.<br><br>
    `,
    cookies_content: `
        <strong>1. Кукиҳо ва нигаҳдории маҳаллӣ чист? </strong><br>
        Кукиҳо ва нигаҳдории маҳаллии браузер файлҳои хурди маълумоте мебошанд, ки дар дастгоҳ нигоҳ дошта мешаванд, то афзалиятҳои конфигуратсияро дар тамоми боздидҳо дар хотир нигоҳ доранд.<br><br>

        <strong>2. Мақсади истифода </strong><br>
        Browser LocalStorage ба таври қатъӣ барои нигоҳ доштани танзимоти конфигуратсия истифода мешавад, масалан: <br>
        - Афзалиятҳои забон <br>
        - Конфигуратсияи интерфейси корбар (масалан, тарҳрезӣ ё танзимоти мавзӯъ) <br>
        - Замимаи муваққатии cache<br><br>

        <strong>3. No Tracking</strong><br>
        Кукиҳо ва нигаҳдории маҳаллӣ барои таблиғ ё пайгирии шахсони сеюм истифода намешаванд. Ҳама маълумоти захирашуда ба таври қатъӣ барои функсияҳои асосии платформа мебошанд.<br><br>

        <strong>4. Control</strong><br>
        Маълумоти браузерро дар вақти дилхоҳ тавассути танзимоти браузер тоза кардан мумкин аст, ки он ҳама конфигуратсияҳои маҳаллиро аз нав барқарор мекунад.
    `,
    cookie_consent_text: "Мо кукиҳои асосиро барои таъмини дурусти вазифаҳои вебсайт истифода мебарем, ба монанди фаъол нигоҳ доштани сессияи шумо, захира кардани афзалияти забони шумо ва дигар конфигуратсияҳои фармоишӣ.",
    read_policy: "Сиёсати кукиҳоро хонед",
    support_title: "Бо дастгирии тамос",
    support_subject_label: "Мавзӯъ",
    support_message_label: "Паём",
    support_submit_button: "Паём фиристед",
    support_hint: "Эзоҳ: Ин барномаи почтаи электронии шуморо барои фиристодани паём мекушояд.",
    support_success_msg: "Кушодани барномаи почтаи электронии шумо...",
    support_error_msg: "фиристодани паём. Лутфан баъдтар бори дигар кӯшиш кунед.",
    explorer_title: "Explorer",
    history_title: "Таърих",
    animation_title: "Аниматсия",
    config_title: "Конфигуратсия",
    tool_mouse: "Интихоб кунед (Ctrl+M)",
    tool_brush: "хасу (Ctrl+B)",
    tool_brush_mode: "Ҳолати гузариш (Сахт/Тоза)",
    tool_eraser: "Хаткӯркунак (Ctrl+E)",
    tool_brush_size: "Андозаи хасро танзим кунед",
    tool_bucket: "Пур кардан (Ctrl+F)",
    tool_eyedropper: "Пӯсти чашм",
    tool_grid: "Шабака (Ctrl+Shift+B)",
    tool_rotate: "Гард кардан (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Гузариш (Ctrl+Shift+T)",
    label_width: "Васеъ",
    label_height: "Баландӣ",
    label_frames: "Шумораи Чорчубахо",
    label_animation: "Услуби аниматсия",
    label_background_color: "Ранги замина",
    label_interval: "Фосила",
    tool_anim_config: "Конфигуратсияи аниматсия",
    label_new_width: "Паҳнои нав",
    label_new_height: "Баландии нав",
    label_apply: "Муроҷиат кунед",
    label_colors: "Рангҳо",
    label_size: "Андоза",
    label_tolerance: "Таҳаммулпазирӣ",
    val_horizontal: "Уфуқӣ",
    val_vertical: "Амудӣ",
    val_sequence: "пайдарпай",
    val_bounce: "Паридан",
    val_random: "Тасодуфӣ",
    val_solid: "Сахт",
    val_clear: "Тоза",
    action_add_sheet: "Варақаи нав",
    action_import: "Воридот",
    action_export: "Содирот",
    action_sort_projects: "Тартиб додан",
    sort_date_old: "Кӯҳнатарин Аввал",
    sort_date_new: "Навтарин Аввал",
    sort_name_az: "Ном (А-З)",
    sort_name_za: "Ном (З-А)",
    action_new_sprite: "Sprite нав",
    action_new_project: "Лоиҳаи нав",
    modal_save_all_title: "Ҳама тағиротҳоро захира кунед",
    modal_save_all_desc: "Барои захира кардани дороиҳо интихоб кунед:",
    modal_save_selected: "Захираи интихобшуда",
    action_saved: "Захира карда шуд",
    modal_create_sprite_title: "Эҷоди Sprite нав",
    modal_create_project_title: "Эҷоди лоиҳаи нав",
    modal_add_sheet_title: "Иловаи варақи нав",
    modal_rename_sheet_title: "Номи варақаро иваз кунед",
    modal_rename_sprite_title: "Номи Sprite-ро иваз кунед",
    modal_delete_sprite_title: "Sprite-ро нест кунед",
    modal_delete_project_title: "Лоиҳаро нест кунед",
    modal_delete_sheet_title: "Нест кардани варақ",
    placeholder_sprite_name: "Ном",
    placeholder_project_name: "Ном",
    placeholder_sheet_name: "Ном",
    placeholder_new_name: "Номи нав",
    action_create: "Эҷод кунед",
    action_add: "Илова",
    action_rename: "Номи дигар",
    action_duplicate: "Дубликат",
    action_delete: "Нобуд кунед",
    action_cancel: "Бекор кардан",
    confirm_delete_sprite: "Шумо мутмаин ҳастед, ки мехоҳед ин спрайтро нест кунед?",
    confirm_delete_project: "Шумо мутмаин ҳастед, ки мехоҳед ин лоиҳаро нест кунед? Ҳама спрайтҳо хориҷ карда мешаванд.",
    confirm_delete_sheet: "Шумо мутмаин ҳастед, ки мехоҳед ин варақаро нест кунед?",
    err_select_sprite: "Лутфан аввал спрайт интихоб кунед.",
    err_select_project: "Лутфан аввал лоиҳаро интихоб кунед.",
    err_name_empty: "Ном холӣ буда наметавонад.",
    err_sprite_exists: "Спрайт бо ин ном аллакай вуҷуд дорад.",
    err_project_exists: "Лоиҳа бо ин ном аллакай вуҷуд дорад.",
    err_no_content: "Мазмуни захира кардан нест.",
    err_no_changes: "Ҳеҷ гуна тағирот барои захира кардан.",
    err_delete_last_sheet: "Варақи охиринро нест кардан мумкин нест.",
    err_extract_frames: "Ягон чаҳорчӯба хориҷ карда нашуд.",
    err_indexeddb: "Ба таври маҳаллӣ захира карда натавонист. Браузери шумо метавонад IndexedDB-ро дастгирӣ накунад.",
    msg_upload_success: "Боргузорӣ бомуваффақият: {0}",
    msg_upload_failed: "Боргузорӣ ноком шуд: {0}",
    msg_save_success: "Бомуваффақият захира кунед.",
    msg_saving: "Захира...",
    msg_multi_save_result: "{0} дороиҳои захирашуда. {1} нокомӣ.",
    menu_title: "Меню",
    menu_save: "Захира кунед",
    menu_save_all: "Ҳамаро захира кунед",
    menu_support: "Бо дастгирии тамос",
    label_local_storage: "Захираи маҳаллӣ",
    label_sign_in: "Даромад",
    modal_export_title: "Содироти Sprite",
    label_filename: "Номи парванда",
    label_format: "Формат",
    action_export_confirm: "Содирот",
};

export default translations;
